@if (data) {
<mat-card class="profile-card px-15 pb-20">
    <mat-card-header>
        <mat-card-title>
            <div class="g-just-flex gap-8">
                <div class="round-icon-wrapper contrast">
                    <mat-icon>person</mat-icon>
                </div>
                <span> Practitioner Details</span>
            </div>
        </mat-card-title>
        @if(dialogRef) {
        <button mat-icon-button (click)="dialogRef.close()" style="position: absolute; right: 16px; top: 16px;"
            aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
        }
    </mat-card-header>

    <mat-card-content>
        <div class="my-10">
            <mat-divider></mat-divider>
            <div class="my-20"></div>

            <div class="g-just-flex special-header-wrapper my-20 mb-12 gap-10"
                style="justify-content: space-between; flex-wrap: wrap;">

                <div class="special-header g-just-flex gap-15" style="align-items: center; flex-wrap: wrap;
                max-width: 100%; width: 100%;">
                    <div class="icon" style="flex: 0 1 140px; max-width: 140px;">
                        <img src="{{data.photo?.[0]?.url || 'https://www.dummyimg.in/placeholder'}}"
                            style="height: 120px; width: 120px; border-radius: 50%;" alt="" srcset="">
                    </div>

                    <div class="words g-just-flex flex-column gap-15"
                        style="align-items: flex-start; font-size: 1.1rem; flex: 1 1 200px;">
                        <div class="g-just-flex flex-column gap-5 align-items-start">
                            <strong>
                                <em>
                                    <span>
                                        @if(data.name && data.name.length > 0){
                                        @let name = data.name[0];
                                        {{name.family | uppercase}} {{name.given?.join(" ")}}
                                        }@else {
                                        <span>No Name Provided</span>
                                        }
                                    </span>
                                </em>
                            </strong>
                            <div class="pb-3 subtitle-text-color-2 small-subtitle" style="font-size: 0.9rem;">
                                {{ 'Practitioner/' + data.id | referenceIdentifier | async }}
                            </div>
                        </div>

                        <div class="g-just-flex gap-20 align-items-start"
                            style="display: flex !important; flex-wrap: wrap; justify-content: flex-start;">
                            @if(data){
                            @let approvedOrNot = data && data.active ? 'Approved' : 'Pending';
                            <div #sc
                                [attr.class]="'small-chips' +' '+' status-'+statuStyles[approvedOrNot.toLowerCase()]['color']+' g-just-flex gap-8'"
                                style="display: flex !important; background-color: var(--mat-sys-surface-variant);">
                                <span> {{approvedOrNot}} </span>
                                <mat-icon>
                                    {{statuStyles[approvedOrNot.toLowerCase()]?.['icon'] || 'info'}}
                                </mat-icon>
                            </div>
                            }

                            @if(practitionerRole$ | async){
                            @for(practitionerRole of (practitionerRole$ | async); track $index) {
@let isNoRole = practitionerRole?.code?.text === 'no role';
@let roleLabel = isNoRole ? 'no role' : (practitionerRole.code | codeableConcept2);
@let roleKey = isNoRole ? 'no role' : normalizeRoleKey(roleLabel);
@let roleStyle = statuStyles[roleKey] || { color: 'gray', icon: 'help_outline', label: roleLabel };
<div class="role-card">
    <div #sc
        [attr.class]="'small-chips status-' + roleStyle.color + ' g-just-flex gap-8'"
        style="display: flex !important; align-items: center; position: relative;">
        <span>
            <mat-icon>
                {{roleStyle.icon}}
            </mat-icon>
        </span>
        <span>
            {{isNoRole ? 'No Role Assigned' : roleLabel}}
        </span>

                                    <!-- ✅ NEW: Show specialty if available -->
                                    @if (practitionerRole.specialty) {
                                    <span class="specialty-badge">
                                        ({{ practitionerRole.specialty }})
                                    </span>
                                    }


                                  @if(!isNoRole) {
@let permissions = getRolePermissions(practitionerRole.code | codeableConcept2);
                                    <mat-icon class="delete-btn" (click)="deleteRole(practitionerRole)"
                                        style="color: var(--mat-sys-on-surface-variant);">delete</mat-icon>
                                    }
                                </div>

                                <!-- ✅ NEW: Show permissions dropdown -->
                          @if(!isNoRole) {
                                @let permissions = getRolePermissions(practitionerRole.code | codeableConcept2);
                                @if(permissions) {
                                <div class="permissions-summary"
                                    style="margin-top: 8px; padding: 8px; background: rgba(0,0,0,0.05); border-radius: 4px; font-size: 0.85rem;">
                                    @if(hasFullAccess(practitionerRole.code | codeableConcept2)) {
                                    <div class="g-just-flex gap-4" style="align-items: center; color: #4caf50;">
                                        <mat-icon
                                            style="font-size: 16px; width: 16px; height: 16px;">check_circle</mat-icon>
                                        <span>Full Access</span>
                                    </div>
                                    }@else {
                                    <div class="permissions-list">
                                        <!-- ✅ FIXED: Only show if array has values -->
                                        @if(permissions.allowedServiceRequestCategories &&
                                        permissions.allowedServiceRequestCategories.length > 0) {
                                        <div class="permission-item">
                                            <strong>Service Requests:</strong>
                                            <span>{{permissions.allowedServiceRequestCategories.join(', ')}}</span>
                                        </div>
                                        }

                                        <!-- ✅ FIXED: Only show if array has values -->
                                        @if(permissions.allowedObservationCategories &&
                                        permissions.allowedObservationCategories.length > 0) {
                                        <div class="permission-item">
                                            <strong>Observations:</strong>
                                            <span>{{permissions.allowedObservationCategories.join(', ')}}</span>
                                        </div>
                                        }

                                        <!-- ✅ FIXED: Only show if at least one custom permission is true -->
                                        @if(permissions.customPermissions &&
                                        hasAnyCustomPermission(permissions.customPermissions)) {
                                        <div class="permission-item">
                                            <strong>Custom:</strong>
                                            <span class="g-just-flex gap-4" style="display: inline-flex;">
                                                @if(permissions.customPermissions.canViewAllPatients) {
                                                <mat-icon style="font-size: 14px;"
                                                    title="Can View All Patients">visibility</mat-icon>
                                                }
                                                @if(permissions.customPermissions.canOrderTests) {
                                                <mat-icon style="font-size: 14px;"
                                                    title="Can Order Tests">science</mat-icon>
                                                }
                                                @if(permissions.customPermissions.canPrescribeMedications) {
                                                <mat-icon style="font-size: 14px;"
                                                    title="Can Prescribe Medications">medication</mat-icon>
                                                }
                                                @if(permissions.customPermissions.canPerformProcedures) {
                                                <mat-icon style="font-size: 14px;"
                                                    title="Can Perform Procedures">healing</mat-icon>
                                                }
                                            </span>
                                        </div>
                                        }

                                        <!-- ✅ NEW: Show message if no permissions configured -->
                                        @if(!permissions.allowedServiceRequestCategories?.length &&
                                        !permissions.allowedObservationCategories?.length &&
                                        !hasAnyCustomPermission(permissions.customPermissions)) {
                                        <div class="permission-item" style="color: #ff9800;">
                                            <mat-icon style="font-size: 14px;">warning</mat-icon>
                                            <span>No specific permissions configured</span>
                                        </div>
                                        }
                                    </div>
                                    }
                                </div>
                                }
                                }
                            </div>
                            }
                            }
                        </div>
                    </div>
                </div>

                <!-- ✅ UPDATED: Action Buttons with Archive/Reactivate -->
                <div class="action-button mb-15 gap-18" style="flex-wrap: wrap;">
                    @if(canAddPatientRegistration()) {

                    @if(data && data.active) {
                    <!-- ✅ APPROVED STATE: Show Update Roles & Archive -->
                    <a mat-flat-button class="header-group" (click)="updateRole()">
                        <mat-icon>person_add</mat-icon>
                        <span>Update Roles</span>
                    </a>
                    <a mat-stroked-button class="header-group" (click)="archivePractitioner()"
                        style="border-color: #ff9800; color: #ff9800;">
                        <mat-icon>archive</mat-icon>
                        <span>Archive</span>
                    </a>
                    }@else if(data && !data.active && data.status === 'active') {
                    <!-- ✅ ARCHIVED STATE: Show Reactivate -->
                    <a mat-flat-button class="header-group" (click)="reactivatePractitioner()"
                        style="background-color: #4caf50; color: white;">
                        <mat-icon>restore</mat-icon>
                        <span>Reactivate</span>
                    </a>
                    }@else {
                    <!-- ✅ PENDING STATE: Show Approve & Reject -->
                    <a mat-flat-button class="header-group" (click)="approvePractitioner()">
                        <mat-icon>check_circle</mat-icon>
                        <span>Approve</span>
                    </a>
                    <a mat-stroked-button class="header-group" (click)="rejectPractitioner()"
                        style="border-color: #f44336; color: #f44336;">
                        <mat-icon>cancel</mat-icon>
                        <span>Reject</span>
                    </a>
                    }
                    }
                </div>
            </div>

            <mat-tab-group>
                <mat-tab label="Details">
                    <div class="cards-wrapper my-30">

                        <!-- Name Card -->
                        @if(data.name && data.name.length > 0){
                        <mat-card style="flex: 1 1 100%; max-width: 100%;">
                            <mat-card-header>
                                <div class="g-just-flex gap-15"
                                    style="align-items: flex-start; justify-content: flex-start;">
                                    <div class="header-words">
                                        <div class="title-flex g-just-flex gap-8"
                                            style="align-items: flex-start; justify-content: flex-start;">
                                            <mat-icon>person</mat-icon>
                                            <mat-card-title>Name</mat-card-title>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="my-10 mt-20">
                                    <div class="my-10"></div>
                                    <div class="card-content-details">
                                        <div class="fields-wrapper g-just-flex gap-15">
                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        {{data.name[0].family || 'N/A'}}
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Last Name / Surname' | titlecase}}
                                                </div>
                                            </div>

                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        {{data.name[0].given?.[0] || 'N/A'}}
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'First Name' | titlecase}}
                                                </div>
                                            </div>

                                            @if(data.name[0].given && data.name[0].given.length > 1){
                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        @for(otherName of data.name[0].given; track $index) {
                                                        @if($index > 0) {
                                                        {{otherName || 'N/A'}}
                                                        }
                                                        }
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Other Names' | titlecase}}
                                                </div>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        }

                        <!-- Bio Data Card -->
                        @if(data.gender || data.birthDate){
                        <mat-card style="flex: 1 1 100%; max-width: 100%;">
                            <mat-card-header>
                                <div class="g-just-flex gap-15"
                                    style="align-items: flex-start; justify-content: flex-start;">
                                    <div class="header-words">
                                        <div class="title-flex g-just-flex gap-8"
                                            style="align-items: flex-start; justify-content: flex-start;">
                                            <mat-icon>info</mat-icon>
                                            <mat-card-title>Bio Data</mat-card-title>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="my-10 mt-20">
                                    <div class="my-10"></div>
                                    <div class="card-content-details">
                                        <div class="fields-wrapper g-just-flex gap-15">
                                            @if(data.birthDate){
                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        {{(data.birthDate | date : "mediumDate") || 'N/A'}}
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Date of Birth' | titlecase}}
                                                </div>
                                            </div>

                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        {{data.birthDate? (data.birthDate | age) +" Years": 'N/A'}}
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Age' | titlecase}}
                                                </div>
                                            </div>
                                            }

                                            @if(data.gender){
                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        {{(data.gender | titlecase) || 'N/A'}}
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Gender' | titlecase}}
                                                </div>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        }

                        <!-- Address Card -->
                        @if(data.address && data.address.length > 0){
                        <mat-card style="flex: 1 1 100%; max-width: 100%;">
                            <mat-card-header>
                                <div class="g-just-flex gap-15"
                                    style="align-items: flex-start; justify-content: flex-start;">
                                    <div class="header-words">
                                        <div class="title-flex g-just-flex gap-8"
                                            style="align-items: flex-start; justify-content: flex-start;">
                                            <mat-icon>home</mat-icon>
                                            <mat-card-title>Address</mat-card-title>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="my-10 mt-20">
                                    <div class="my-10"></div>
                                    <div class="card-content-details">
                                        <div class="fields-wrapper g-just-flex gap-15">
                                            @for(address of data.address; track $index) {
                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        {{address.line?.join(", ") || 'N/A'}}
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Address Line' | titlecase}}
                                                </div>
                                            </div>

                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        {{address.city || 'N/A'}}
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'City' | titlecase}}
                                                </div>
                                            </div>

                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        {{address.state || 'N/A'}}
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'State' | titlecase}}
                                                </div>
                                            </div>

                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        {{address.country || 'N/A'}}
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Country' | titlecase}}
                                                </div>
                                            </div>

                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        {{address.postalCode || 'N/A'}}
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Postal Code' | titlecase}}
                                                </div>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        }

                        <!-- Contact Details Card -->
                        @if(data.telecom && data.telecom.length > 0){
                        <mat-card style="flex: 1 1 100%; max-width: 100%;">
                            <mat-card-header>
                                <div class="g-just-flex gap-15"
                                    style="align-items: flex-start; justify-content: flex-start;">
                                    <div class="header-words">
                                        <div class="title-flex g-just-flex gap-8"
                                            style="align-items: flex-start; justify-content: flex-start;">
                                            <mat-icon>contact_phone</mat-icon>
                                            <mat-card-title>Contact Details</mat-card-title>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="my-10 mt-20">
                                    <div class="my-10"></div>
                                    <div class="card-content-details">
                                        <div class="fields-wrapper g-just-flex gap-15">
                                            @for(telecom of data.telecom; track $index) {
                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        {{telecom.value || 'N/A'}}
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    @if(telecom.use || telecom.system){
                                                    @if(telecom.system){
                                                    {{(telecom.system | titlecase)}}
                                                    }
                                                    @if(telecom.use) {
                                                    {{" - " + (telecom.use | titlecase)}}
                                                    }
                                                    }@else {
                                                    {{'Contact'}}
                                                    }
                                                </div>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        }
                    </div>
                </mat-tab>

                <mat-tab label="Attachment">
                    @if(data.photo && data.photo.length > 0) {
                    <div class="cards-wrapper my-30">
                        @for(att of data.photo; track $index) {
                        <mat-card>
                            <mat-card-header>
                                <div class="g-just-flex gap-15"
                                    style="align-items: flex-start; justify-content: flex-start;">
                                    <div class="header-words">
                                        <div class="title-flex g-just-flex gap-8"
                                            style="align-items: flex-start; justify-content: flex-start;">
                                            <mat-icon>attach_file</mat-icon>
                                            <mat-card-title>Attachment</mat-card-title>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="my-10 mt-20">
                                    <div class="my-10"></div>
                                    <div class="card-content-details">
                                        <div class="fields-wrapper g-just-flex gap-15">
                                            <div class="field-group" style="min-width: 280px;">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        @if(att.url){
                                                        <img [src]="att.url" alt="attachment"
                                                            style="max-height: 160px; border-radius: 6px;" />
                                                        }@else if(att.data && att.contentType){
                                                        <img [src]="'data:' + att.contentType + ';base64,' + att.data"
                                                            alt="attachment"
                                                            style="max-height: 160px; border-radius: 6px;" />
                                                        }@else {
                                                        <mat-icon>insert_drive_file</mat-icon>
                                                        }
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Preview' | titlecase}}
                                                </div>
                                            </div>

                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        {{att.title || 'N/A'}}
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Title' | titlecase}}
                                                </div>
                                            </div>

                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        {{att.contentType || 'N/A'}}
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Content Type' | titlecase}}
                                                </div>
                                            </div>

                                            @if(att.creation){
                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        {{att.creation | date: 'medium'}}
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Created' | titlecase}}
                                                </div>
                                            </div>
                                            }

                                            @if(att.url){
                                            <div class="field-group">
                                                <div class="field-value">
                                                    <div #sc class="value-with-icon">
                                                        <a [href]="att.url" target="_blank">Open</a>
                                                    </div>
                                                </div>
                                                <div class="field-title">
                                                    {{'Link' | titlecase}}
                                                </div>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        }
                    </div>
                    }@else {
                    <div class="g-just-flex flex-column gap-15" style="align-items: center; justify-content: center;">
                        <mat-icon class="icon" style="font-size: 3rem;">info</mat-icon>
                        <span class="subtitle-text-color-2">No Attachment Found</span>
                    </div>
                    }
                </mat-tab>
            </mat-tab-group>
        </div>
    </mat-card-content>
</mat-card>
}
